import React from 'react';
import * as styles from './LoanPurposeButtons.module.scss';
import useInitialValue from '@hooks/useInitialValue';
import classNames from 'classnames';
import Refinance from './refinance.svg';
import Purchase from './purchase.svg';
import { loanPurpose as loanPurposeType } from '@enums';

export default React.memo(function LoanPurposeButtons({
  loanPurpose = 'refinance',
  labelId,
  setState
}) {
  loanPurpose = loanPurpose.toLowerCase();
  const defaultValue = useInitialValue(loanPurpose);

  const components = [
    <LoanPurpose
      key="refinance"
      type={loanPurposeType.REFINANCE}
      isActive={loanPurpose === loanPurposeType.REFINANCE}
      setState={setState}
    >
      Refinance
    </LoanPurpose>,
    <LoanPurpose
      key="purchase"
      type={loanPurposeType.PURCHASE}
      isActive={loanPurpose === loanPurposeType.PURCHASE}
      setState={setState}
    >
      Purchase
    </LoanPurpose>
  ];

  // Display the default type first
  if (defaultValue === loanPurposeType.PURCHASE) {
    components.reverse();
  }

  return (
    <div
      className={styles.wrapper}
      role="group"
      aria-labelledby={labelId}
    >
      <div className={styles.toggleBgWrapper}>
        <div
          className={classNames(styles.toggleBg, {
            [styles.right]: loanPurpose !== defaultValue
          })}
        />
      </div>
      {components}
    </div>
  );
});

function LoanPurpose({ type, isActive, children, setState }) {
  return (
    <button
      type="button"
      name="Loan Purpose"
      className={classNames(styles.button, {
        [styles.active]: isActive
      })}
      onClick={() => setState(type, 'loanPurpose')}
      aria-pressed={isActive}
    >
      <span className={classNames(styles.iconWrapper)}>
        {type === 'refinance' ? <Refinance /> : <Purchase />}
      </span>
      <span>{children}</span>
    </button>
  );
}
